import React from "react";
import Sidebar from "./Sidebar";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";

const Main = () => {
	return (
		<div style={{margin:'auto'}}>
			<Sidebar />
			<About />
			<Projects />
			<Contact />
		</div>
	);
};

export default Main;
